import { PageShell } from '../components/PageShell'
import { SettingsTabContent } from '../panels/SettingsTab'
import { Settings } from 'lucide-react'

export function SettingsPage() {
  return (
    <PageShell
      pageId="settings"
      title="Panel de Control"
      subtitle="Configuracion"
      icon={<Settings size={22} />}
    >
      <SettingsTabContent />
    </PageShell>
  )
}
